export default [
    "18 18",
    '<path d="M15.75 15.75H2.25M13.5 8.25L9 12.75M9 12.75L4.5 8.25M9 12.75V2.25" fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
]
